$(function() {
	let tabs = $(".js-tab-btn");
	$(".js-tab-btn").on("click", function() {
			$(".is-active").removeClass("is-active");
			$(this).addClass("is-active");
			const index = tabs.index(this);
			$(".js-tab-content").removeClass("is-show").eq(index).addClass("is-show");
	});
});
